import styled from "styled-components";

export const Header2 = styled.h2`
  position: relative;
  font-family: Impact, "Anton", sans-serif;
  line-height: 8.5rem;
  color: var(--primary);
  text-transform: uppercase;
  white-space: nowrap;

  font-size: 5.5rem;
  @media only screen and (max-width: 1000px) {
    white-space: normal;
    line-height: 1.05;
  }
  @media only screen and (max-width: 600px) {
    font-size: 4.3rem;
    line-height: 1;
  }
`;
